// src/utilities/helper.js
export const newTimeout = delay => new Promise( res => setTimeout(res, delay) );

export const getUrlExtension = url => url.split(/[#?]/)[0].split('.').pop().trim()
